import React, { useRef } from 'react';
import { FI_BLOB_GRADIENT, FI_BLOB_PATH, FI_FONT_FEATURE_SETTINGS } from './fi-styles';

/** Small Fi blob for chat message rows. */
export const FiBlobAvatar: React.FC<{ size?: number }> = ({ size = 28 }) => {
  const gradientIdRef = useRef(`fi-msg-blob-${Math.random().toString(36).slice(2, 11)}`);
  const gradientId = gradientIdRef.current;

  return (
    <div
      className="relative inline-grid shrink-0 place-items-center leading-[0]"
      style={{ width: size, height: size }}
      aria-hidden
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 83 83"
        fill="none"
        className="col-start-1 row-start-1"
      >
        <defs>
          <linearGradient
            id={gradientId}
            x1={FI_BLOB_GRADIENT.x1}
            y1={FI_BLOB_GRADIENT.y1}
            x2={FI_BLOB_GRADIENT.x2}
            y2={FI_BLOB_GRADIENT.y2}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF815B" />
            <stop offset="1" stopColor="#FFB973" />
          </linearGradient>
        </defs>
        <path d={FI_BLOB_PATH} fill={`url(#${gradientId})`} />
      </svg>
      <span
        className="font-albert-sans relative z-[1] col-start-1 row-start-1 grid place-items-center font-semibold leading-none text-white"
        style={{ width: size, height: size, fontSize: Math.round(size * 0.42), ...FI_FONT_FEATURE_SETTINGS }}
      >
        fi
      </span>
    </div>
  );
};
